import React from 'react';
import {v4 as uuidv4} from 'uuid';

import {AppContext} from '../../AppModule/Context';
import {withWidgetContext} from '../widgetComponent/widgetContextProvider';

import CFooterComponent from '../widgetComponent/openWidgetComponent/cFooterComponent';
import ChatContainer from '../chatComponents/chatContainer';
import PoweredByConsoltoComponent from '../widgetComponent/openWidgetComponent/poweredByConsoltoComponent';
import LanguageSelectorComponent from '../widgetComponent/openWidgetComponent/languageSelectorComponent';
import LeadCollectorComponent from '../widgetComponent/openWidgetComponent/leadCollectorComponent';
import CustomLinkComponent from '../widgetComponent/openWidgetComponent/customLinkComponent';
import MessengerComponent from '../widgetComponent/openWidgetComponent/messengerComponent';
import PersonalPageMentorInfo from './personalPageMentorInfo';
import PersonalPageSchedulingComponent from '../scheduleComponents/clientSchedulingComponents/personalPage/personalPageSchedulingComponent';
import PhoneCallComponent from '../widgetComponent/openWidgetComponent/phoneCallComponent';
import SinglePrivateHeaderChatBtnsComponent from '../chatComponents/singlePrivateHeaderChatBtnsComponent';
import WhatsappComponent from '../widgetComponent/openWidgetComponent/whatsappComponent';
import WidgetsRedirectComponent from '../widgetComponent/openWidgetComponent/widgetsRedirectComponent';
import WidgetVideoComponent from '../widgetComponent/openWidgetComponent/widgetVideoComponent';

import utilsService from '../../services/utilsService';

import VIDABOO_CONSTANTS from '../../config/consts';

import './personalPageComponent.css';

class PersonalPageComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      waitingPopupMessage: null,
      currentSelectedFile: null,
      showSendFileComponent: false,
      dragStarted: false,
      isWithButton: false,
    };
  }

  componentDidMount = () => {
    window.addEventListener('dragenter', this.handleDragEnter);
    window.addEventListener('dragleave', this.handleDragLeave);
    // Check if peerClient info is present in URL
    const allParams = new URLSearchParams(document.location.search);
    const cFirstName = allParams.get('cFirstName');
    const cLastName = allParams.get('cLastName');
    const cPhone = allParams.get('cPhone');
    const cEmail = allParams.get('cEmail');
    const cMessage = allParams.get('cMessage');
    // if firstName and email are present then send it
    if (cFirstName && cEmail) {
      const peerInfo = {
        cFirstName,
        cLastName,
        cPhone,
        cEmail,
        mentorOwnerId: this.props.extendedMentorDto.mentorDto.mentorOwnerId,
        mentorId: this.props.extendedMentorDto.mentorDto.mentorId,
      };
      let sendInfo = utilsService.savePeerClientInfo(
        peerInfo,
        this.props.widgetDto,
      );

      if (sendInfo) {
        utilsService.updateNeedSendPeerInfo(
          false,
          this.props.extendedMentorDto.mentorDto.mentorId,
        );
        this.callSendMessageFunc(
          'Inbox Message',
          VIDABOO_CONSTANTS.CHAT_SUBTYPES.INFO_MESSAGE,
          JSON.stringify({
            recieverUserId:
              this.props.extendedMentorDto.mentorDto.mentorOwnerId,
            senderUserId: 'GUEST',
            subject: 'Name & Email of your potential client.',
            content: [
              {
                answers: cEmail,
                field_name: 'email',
                questionType: VIDABOO_CONSTANTS.QUESTION_TYPE.EMAIL,
                title: 'Email',
              },
              {
                answers: cFirstName + (cLastName ? ' ' + cLastName : ''),
                field_name: 'name',
                questionType: VIDABOO_CONSTANTS.QUESTION_TYPE.SINGLE_LINE,
                title: 'Name',
              },
              {
                answers: cPhone,
                field_name: 'phone_number',
                questionType: VIDABOO_CONSTANTS.QUESTION_TYPE.PHONE_NUMBER,
                title: 'Phone Number',
              },
              {
                answers: cMessage,
                field_name: 'message',
                questionType: VIDABOO_CONSTANTS.QUESTION_TYPE.MULTI_LINE,
                title: 'Message',
              },
            ],
            submissionPageUrl: document.location.href,
            version: 'v2',
            createdTime: Date.now(),
          }),
        );
      }
    }
    this.setInitialSelectedWidgetAppType();
    utilsService.assignMentorCustomizationValues(
      this.props.extendedMentorDto.mentorDto.appControlDto.style,
      this.props.widgetDto.widgetAppCtrlDto.style,
    );
    utilsService.setCustomerPageFaviconAndPageTitleWithPriority({
      mentorDisplayName: this.props.extendedMentorDto.mentorDto.displayName,
      mentorPhotoUrl: this.props.extendedMentorDto?.photoDto?.photoUrl,
      mentorWhiteLabel:
        this.props.extendedMentorDto.mentorDto.appControlDto.whiteLabel,
      publicResellerAgencyDto: this.props.widgetDto?.publicResellerAgencyDto,
    });
  };

  componentDidUpdate = () => {
    if (this.context.callState && this.context.callState !== this.callState) {
      if (
        (this.callState ===
          VIDABOO_CONSTANTS.VIDEO_CALL_STATE.GETTING_VIDEO_FROM_PEER ||
          this.callState ===
            VIDABOO_CONSTANTS.VIDEO_CALL_STATE.CALL_IN_PROGRESS) &&
        this.context.callState === VIDABOO_CONSTANTS.VIDEO_CALL_STATE.INIT
      ) {
        this.sendStartChatGA();
        this.props.setSelectedWidgetAppType(
          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT,
        );
      }
      this.callState = this.context.callState;
    }
  };

  componentWillUnmount = () => {
    window.removeEventListener('dragenter', this.handleDragEnter);
    window.removeEventListener('dragleave', this.handleDragLeave);
  };

  setInitialSelectedWidgetAppType = () => {
    if (!this.props.selectedWidgetAppType) {
      let selectedWidgetAppType = VIDABOO_CONSTANTS.WIDGET_APP_TYPES.NONE;
      const searchUrl = window.location.search;
      if (searchUrl.includes('?')) {
        const widgetAppType = new URLSearchParams(searchUrl).get('start');
        if (widgetAppType) {
          selectedWidgetAppType =
            utilsService.getSelectedWidgetAppType(widgetAppType);
        } else if (this.props.bfi) {
          selectedWidgetAppType = VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL;
        }
      }
      this.props.setSelectedWidgetAppType(selectedWidgetAppType);
    } else if (
      this.props.selectedWidgetAppType ===
      VIDABOO_CONSTANTS.WIDGET_APP_TYPES.ACTION_SELECTOR
    ) {
      this.props.setSelectedWidgetAppType(
        VIDABOO_CONSTANTS.WIDGET_APP_TYPES.NONE,
      );
    }
  };

  handleDragEnter = (e) => {
    e.preventDefault();
    if (
      this.props.selectedWidgetAppType ===
      VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT
    ) {
      var dt = e.dataTransfer;
      if (
        dt.types &&
        (dt.types.indexOf
          ? dt.types.indexOf('Files') !== -1
          : dt.types.contains('Files'))
      ) {
        this.setState({dragStarted: true});
      }
    }
  };

  handleDragLeave = (e) => {
    e.preventDefault();
    if (!e.fromElement) {
      this.setState({dragStarted: false});
    }
  };

  sendStartChatGA = () => {
    this.sendGA(
      VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.OPEN_CHAT,
      this.props.extendedMentorDto.mentorDto.profileName,
    );
  };

  startVideochat = (peerClientInfo, isCallAudioOnly, isWithButton) => {
    // if (
    //   this.context.peersStatus[
    //     this.props.extendedMentorDto.mentorDto.mentorOwnerId
    //   ] === undefined &&
    //   isWithButton
    // ) {
    //   this.automatedCallsAndBfiRef.current.setNotificationPopuForWebCall(
    //     true,
    //     'Igniting the connection engine…',
    //   );
    // } else {
    //   this.automatedCallsAndBfiRef.current.closePopups();
    // }

    this.setState({
      isWithButton,
    });
    this.props.startVideochat(
      peerClientInfo,
      isCallAudioOnly,
      isWithButton ? false : true,
    );
  };
  sendGA = (eventAction, label) => {
    this.props.sendGA(eventAction, label);
  };
  callSendMessageFunc = (msg, msgType, metaData) => {
    if (msgType === VIDABOO_CONSTANTS.CHAT_SUBTYPES.VIDEOCHAT_MESSAGE) {
      const callReqId = uuidv4();
      this.props?.widgetContext?.setCallReqId(callReqId);
      const mentorAvailabilityStatus =
        this.context.peersStatus[
          this.props.extendedMentorDto.mentorDto.mentorOwnerId
        ];

      metaData = JSON.stringify({callReqId, mentorAvailabilityStatus});
    }
    if (
      this.refToChatContainer &&
      this.refToChatContainer.callSendMessageFunc
    ) {
      this.refToChatContainer.callSendMessageFunc(msg, msgType, metaData);
    } else {
      setTimeout(() => {
        console.debug('callSendMessageFunc');
        this.callSendMessageFunc(msg, msgType, metaData);
      }, 150);
    }
  };

  // File sharing from here...
  handleFileDrop = (file) => {
    this.setState({currentSelectedFile: file, showSendFileComponent: true});
  };
  openCloseSendFileComponent = (currentStateToShowPopup, file) => {
    this.setState({
      showSendFileComponent: currentStateToShowPopup,
      currentSelectedFile: file,
    });
  };

  onPrivateChatTabClicked = () => {
    this.props.widgetContext.setSelectedChatRoomId(
      this.props.widgetContext.privateChatRoomDto.privateChatRoomId,
    );
  };

  onSingleChatTabClicked = () => {
    this.props.widgetContext.setSelectedChatRoomId(
      this.props.extendedMentorDto.mentorDto.mentorOwnerId,
    );
  };

  setRefreshShouldCollectUserInfo = (refreshShouldCollectUserInfo) => {
    this.setState({refreshShouldCollectUserInfo});
  };

  render() {
    const {callState, otVideoContainerSize} = this.context;
    const currentUser = this.context.getCurrentUser();
    const {privateChatRoomDto, selectedChatRoomId} = this.props.widgetContext;
    const {
      dragStarted,
      isWithButton,
      currentSelectedFile,
      refreshShouldCollectUserInfo,
      showSendFileComponent,
    } = this.state;
    const {
      isAutomatedCallHandled,
      isClearedManually,
      isDemo,
      showNotificationPopupForWait,
      bfi,
      extendedMentorDto,
      mentor,
      permissionsStatusesObj,
      postCallFail,
      sessionTemplate,
      startValueFromQuery,
      widgetDto,
      clearAutomatedCallLoop,
      handlePermissionsSuccess,
      onFooterOptionSelected,
      selectedWidgetAppType,
      setIsAutomatedCallHandled,
      setIsCallAudioOnly,
      setPermissionsStatusesObj,
      setShowPermissionsPopup,
    } = this.props;
    const callIsActive =
      callState === VIDABOO_CONSTANTS.VIDEO_CALL_STATE.CALL_IN_PROGRESS ||
      callState ===
        VIDABOO_CONSTANTS.VIDEO_CALL_STATE.GETTING_VIDEO_FROM_PEER ||
      callState === VIDABOO_CONSTANTS.VIDEO_CALL_STATE.SENDING_VIDEO_TO_PEER;
    const showChat =
      selectedWidgetAppType === VIDABOO_CONSTANTS.WIDGET_APP_TYPES.TEXT_CHAT ||
      callIsActive;

    return (
      <React.Fragment>
        <div
          className={`et-personal-page-container ${callIsActive ? 'et-pp-call-active' : ''}`}>
          <div
            className={
              `et-personal-page-content-wrap ` +
              (callIsActive
                ? otVideoContainerSize ===
                  VIDABOO_CONSTANTS.ACTIVE_VIDEO_SIZE.MEDIUM
                  ? 'et-video-size-medium'
                  : otVideoContainerSize ===
                      VIDABOO_CONSTANTS.ACTIVE_VIDEO_SIZE.FULL_SCREEN
                    ? 'et-video-size-large'
                    : ''
                : '')
            }
            onDrop={(e) => {
              e.preventDefault();
              this.setState({dragStarted: false});
              if (e.dataTransfer.files.length > 0) {
                this.handleFileDrop(e.dataTransfer.files[0]);
              }
            }}
            onDragOver={(e) => {
              e.preventDefault();
            }}
            onPaste={(event) => {
              var items = (
                event.clipboardData || event.originalEvent.clipboardData
              ).items;
              for (let index in items) {
                var item = items[index];
                if (item.kind === 'file') {
                  var blob = item.getAsFile();
                  this.handleFileDrop(blob);
                }
              }
            }}>
            {!isDemo &&
              (mentor.mentorDto?.appControlDto?.widgetLanguageSelectorEnabled ||
                widgetDto.widgetAppCtrlDto?.widgetLanguageSelectorEnabled) && (
                <div className="et-pp-language-selector-wrap">
                  <LanguageSelectorComponent
                    isPersonalPage
                    props={this.props}
                  />
                </div>
              )}
            <div className="et-personal-page-tabs-content-wrap">
              {selectedWidgetAppType !==
                VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING && (
                <PersonalPageMentorInfo
                  extendedMentorDto={extendedMentorDto}
                  selectedWidgetAppType={selectedWidgetAppType}
                />
              )}
              <div
                className={`${showChat ? 'et-pp-chat-wrap' : 'et-pp-chat-hidden'}`}
                // className={
                //   !showChat
                //     ? 'et-pp-chat-hidden'
                //     : 'et-pp-chat-wrap ' +
                //       (callIsActive
                //         ? 'et-pp-chat-in-videochat'
                //         : 'et-pp-chat-only')
                // }
              >
                {/* <PersonalPageMentorInfo
                      extendedMentorDto={this.props.extendedMentorDto}
                    /> */}
                {/* <div
                      className={`et-pp-chat-container-wrap ${
                        privateChatRoomDto?.privateChatRoomId
                          ? 'et-pp-single-private-chat-container-wrap'
                          : ''
                      }`}> */}
                {/* {privateChatRoomDto?.privateChatRoomId && (
                      <SinglePrivateHeaderChatBtnsComponent
                        isPrivateChatTabSelected={
                          selectedChatRoomId ===
                          privateChatRoomDto.privateChatRoomId
                        }
                        isSingleChatTabSelected={
                          selectedChatRoomId ===
                          extendedMentorDto.mentorDto.mentorOwnerId
                        }
                        privateTabTxt={`${privateChatRoomDto.participantsCount} Participants`}
                        singleTabTxt={extendedMentorDto.mentorDto.displayName}
                        onPrivateChatTabClicked={this.onPrivateChatTabClicked}
                        onSingleChatTabClicked={this.onSingleChatTabClicked}
                      />
                    )} */}
                <ChatContainer
                  dragStarted={dragStarted}
                  isDemo={isDemo}
                  isInWidget={false}
                  isMentor={false}
                  isPersonalPage={true}
                  isVideo={false}
                  refreshShouldCollectUserInfo={refreshShouldCollectUserInfo}
                  showSendFileComponent={showSendFileComponent}
                  widgetDto={widgetDto}
                  currentSelectedFile={currentSelectedFile}
                  currentUser={currentUser}
                  // fncObj={this.fncObjToChatContainer}
                  mentor={mentor}
                  ppChatTitleComp={
                    <>
                      {privateChatRoomDto?.privateChatRoomId ? (
                        <SinglePrivateHeaderChatBtnsComponent
                          isPrivateChatTabSelected={
                            selectedChatRoomId ===
                            privateChatRoomDto.privateChatRoomId
                          }
                          isSingleChatTabSelected={
                            selectedChatRoomId ===
                            extendedMentorDto.mentorDto.mentorOwnerId
                          }
                          privateTabTxt={`${privateChatRoomDto.participantsCount} Participants`}
                          singleTabTxt={extendedMentorDto.mentorDto.displayName}
                          onPrivateChatTabClicked={this.onPrivateChatTabClicked}
                          onSingleChatTabClicked={this.onSingleChatTabClicked}
                        />
                      ) : (
                        <div className="et-pp-chat-container-title">
                          {`Chat ${
                            extendedMentorDto.mentorDto?.displayName
                              ? ` with ${this.props.extendedMentorDto.mentorDto.displayName}`
                              : ''
                          }
                              `}
                        </div>
                      )}
                    </>
                  }
                  restrictToPeer={mentor.mentorDto.mentorId}
                  selectedWidgetAppType={selectedWidgetAppType}
                  // startChatObj={this.state.startChatObj}
                  dispatchConsoltoEvents={() => {}}
                  onRef={(ref) => (this.refToChatContainer = ref)}
                  openCloseSendFileComponent={this.openCloseSendFileComponent}
                  onFooterOptionSelected={onFooterOptionSelected}
                  sendGA={this.sendGA}
                />
              </div>
              {/* </div> */}
              {!callIsActive && (
                <>
                  {selectedWidgetAppType ===
                    VIDABOO_CONSTANTS.WIDGET_APP_TYPES.FB_MESSENGER && (
                    <MessengerComponent
                      isPersonalPage
                      currentUser={currentUser}
                      mentor={extendedMentorDto}
                      callSendMessageFunc={this.callSendMessageFunc}
                      dispatchConsoltoEvents={() => {}}
                      sendGA={this.sendGA}
                    />
                  )}
                  {selectedWidgetAppType ===
                    VIDABOO_CONSTANTS.WIDGET_APP_TYPES.CUSTOM_LINK && (
                    <CustomLinkComponent
                      isPersonalPage
                      currentUser={currentUser}
                      mentor={extendedMentorDto}
                      callSendMessageFunc={this.callSendMessageFunc}
                      dispatchConsoltoEvents={() => {}}
                      sendGA={this.sendGA}
                    />
                  )}
                  {selectedWidgetAppType ===
                    VIDABOO_CONSTANTS.WIDGET_APP_TYPES.INFO_COLLECTOR && (
                    <LeadCollectorComponent
                      isDemo={isDemo}
                      isPersonalPage
                      currentUser={currentUser}
                      mentor={mentor}
                      // todo : ENABLE_PAY_PER_LEAD : uncomment this
                      // paymentFlowType={
                      //   VIDABOO_CONSTANTS
                      //     .C2C_MONEY_TRANSACTION_PAYMENT_FLOW_TYPE
                      //     .POST_LEAD_COLLECTOR
                      // }
                      selectedWidgetAppType={selectedWidgetAppType}
                      callbackSuccessInfoSend={() => {
                        onFooterOptionSelected(
                          VIDABOO_CONSTANTS.WIDGET_APP_TYPES.POST_FORM_SUBMIT,
                        );
                        this.setRefreshShouldCollectUserInfo(true);
                      }}
                      callSendMessageFunc={this.callSendMessageFunc}
                      dispatchConsoltoEvents={() => {}}
                      sendGA={this.sendGA}
                    />
                  )}
                  {selectedWidgetAppType ===
                    VIDABOO_CONSTANTS.WIDGET_APP_TYPES.PHONE_CALL && (
                    <PhoneCallComponent
                      isPersonalPage
                      currentUser={currentUser}
                      mentor={extendedMentorDto}
                      callSendMessageFunc={this.callSendMessageFunc}
                      dispatchConsoltoEvents={() => {}}
                      sendGA={this.sendGA}
                    />
                  )}
                  {selectedWidgetAppType ===
                    VIDABOO_CONSTANTS.WIDGET_APP_TYPES.SCHEDULE_MEETING && (
                    <PersonalPageSchedulingComponent
                      currentUser={currentUser}
                      extendedMentorDto={extendedMentorDto}
                      callSendMessageFunc={this.callSendMessageFunc}
                      sendGA={this.sendGA}
                      widgetDto={this.props.widgetDto}
                    />
                  )}
                  {selectedWidgetAppType ===
                    VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WEBCALL && (
                    <WidgetVideoComponent
                      isAutomatedCallHandled={isAutomatedCallHandled}
                      isClearedManually={isClearedManually}
                      isDemo={isDemo}
                      isPersonalPage
                      isWithButton={isWithButton}
                      showNotificationPopupForWait={
                        showNotificationPopupForWait
                      }
                      bfi={bfi}
                      callState={callState}
                      mentor={mentor}
                      permissionsStatusesObj={permissionsStatusesObj}
                      postCallFail={postCallFail}
                      sessionTemplate={sessionTemplate}
                      startValueFromQuery={startValueFromQuery}
                      callSendMessageFunc={this.callSendMessageFunc}
                      clearAutomatedCallLoop={clearAutomatedCallLoop}
                      handlePermissionsSuccess={handlePermissionsSuccess}
                      onFooterOptionSelected={onFooterOptionSelected}
                      sendGA={this.sendGA}
                      sendStartChatGA={this.sendStartChatGA}
                      setIsAutomatedCallHandled={setIsAutomatedCallHandled}
                      setIsCallAudioOnly={setIsCallAudioOnly}
                      setPermissionsStatusesObj={setPermissionsStatusesObj}
                      setRefreshShouldCollectUserInfo={
                        this.setRefreshShouldCollectUserInfo
                      }
                      setShowPermissionsPopup={setShowPermissionsPopup}
                      startVideochat={this.startVideochat}
                    />
                  )}
                  {selectedWidgetAppType ===
                    VIDABOO_CONSTANTS.WIDGET_APP_TYPES.WHATSAPP && (
                    <WhatsappComponent
                      isPersonalPage
                      currentUser={currentUser}
                      mentor={extendedMentorDto}
                      callSendMessageFunc={this.callSendMessageFunc}
                      dispatchConsoltoEvents={() => {}}
                      sendGA={this.sendGA}
                    />
                  )}
                  {[
                    VIDABOO_CONSTANTS.WIDGET_APP_TYPES.POST_CALL_FAIL,
                    VIDABOO_CONSTANTS.WIDGET_APP_TYPES.POST_FORM_SUBMIT,
                  ].includes(selectedWidgetAppType) && (
                    <WidgetsRedirectComponent
                      isPersonalPage
                      mentor={mentor}
                      widgetsRedirectType={
                        selectedWidgetAppType ===
                        VIDABOO_CONSTANTS.WIDGET_APP_TYPES.POST_CALL_FAIL
                          ? VIDABOO_CONSTANTS.WIDGETS_REDIRECT_TYPES
                              .POST_CALL_FAIL_WIDGETS
                          : VIDABOO_CONSTANTS.WIDGETS_REDIRECT_TYPES
                              .POST_FORM_SUBMIT_WIDGETS
                      }
                      onFooterOptionSelected={onFooterOptionSelected}
                    />
                  )}
                </>
              )}
            </div>
            <CFooterComponent
              disableIconsAnim
              isDemo={isDemo}
              isPersonalPage
              mentor={mentor}
              selectedWidgetAppType={selectedWidgetAppType}
              onFooterOptionSelected={onFooterOptionSelected}
            />
          </div>
          {!extendedMentorDto?.mentorDto?.appControlDto?.whiteLabel && (
            <PoweredByConsoltoComponent
              isDemo={isDemo}
              category={VIDABOO_CONSTANTS.ANALYTICS_CATEGORIES.FRONT_PAGE}
              eventAction={
                VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.FRONT_PAGE.CONSOLTO_LINK
              }
              mentorDto={mentor.mentorDto}
              utmMedium={VIDABOO_CONSTANTS.UTM_MEDIUMS.PERSONAL_PAGE}
            />
          )}
        </div>
      </React.Fragment>
    );
  }
}

PersonalPageComponent.contextType = AppContext;
export default withWidgetContext(PersonalPageComponent);
